import type { TreeItem, Tree, ScenarioState } from "../types";

const getNearestParentInputRelatedId = (
  item: TreeItem,
  tree: Tree,
): string | null => {
  let currentItem = item;
  while (currentItem && currentItem.parentId !== null) {
    if (currentItem.relatedModelDataId !== null) {
      return currentItem.relatedModelDataId;
    }
    currentItem = tree.items[currentItem.parentId];
  }
  return null;
};

export const shouldBeConsidered = (
  item: TreeItem,
  tree: Tree,
  currentState: ScenarioState,
): boolean => {
  if (item.kind === "Input") {
    if (item.sensitivityModelData == null) {
      return true;
    }
    let currentItem: TreeItem = item;
    while (currentItem.parentId !== null) {
      if (currentItem.sensitivityModelData?.to_consider === false) {
        return false;
      }
      currentItem = tree.items[currentItem.parentId];
    }
    return true;
  }

  if (item.kind === "Output") {
    const relatedModelId = getNearestParentInputRelatedId(
      item,
      currentState["Output"].tree,
    );

    if (relatedModelId == null) {
      return true;
    }

    const inputTree = currentState["Input"].tree;
    const inputItem = inputTree.items[relatedModelId];

    if (!inputItem || inputItem.sensitivityModelData == null) {
      return true;
    }

    let currentItem: TreeItem = inputItem;
    while (currentItem.parentId !== null) {
      if (currentItem.sensitivityModelData?.to_consider === false) {
        return false;
      }
      currentItem = inputTree.items[currentItem.parentId];
    }
    return true;
  }

  return true;
};

export const parentConsidered = (item: TreeItem, tree: Tree): boolean => {
  if (item.sensitivityModelData == null) {
    return true;
  }
  let currentItem: TreeItem = tree.items[item.parentId!];
  while (currentItem.parentId !== null) {
    if (currentItem.sensitivityModelData?.to_consider === false) {
      return false;
    }
    currentItem = tree.items[currentItem.parentId];
  }
  return true;
};

export const isModifiedInSensitivity = (
  item: TreeItem,
  sensitivityModifiedIds: Set<string> | undefined,
): boolean => {
  if (!item) return false;
  return sensitivityModifiedIds?.has(item.id?.toString()) || false;
};

export const isModifiedInSensitivityTree = (
  item: TreeItem,
  tree: Tree,
): boolean => {
  if (!item || item.sensitivityModelData == null) return false;
  return (
    Object.keys(item.sensitivityModelData.fields).length !== 0 ||
    item.childrens.some(
      (id) => tree.items[id] && isModifiedInSensitivityTree(tree.items[id], tree),
    )
  );
};
